const OPENFREEMAP_STYLE_BASE = 'https://tiles.openfreemap.org/styles';

const openFreeMapStyle = (styleName) => `${OPENFREEMAP_STYLE_BASE}/${styleName}`;

export const OSM_STYLE = openFreeMapStyle('liberty');
export const FIORD_STYLE = openFreeMapStyle('fiord');
export const DARK_STYLE = openFreeMapStyle('dark');
export const LIGHT_STYLE = openFreeMapStyle('positron');
export const VOYAGER_STYLE = openFreeMapStyle('bright');

export const BASEMAPS = {
  osm: {
    id: 'osm',
    name: 'Streets',
    style: OSM_STYLE,
  },
  fiord: {
    id: 'fiord',
    name: 'Fiord',
    style: FIORD_STYLE,
  },
  dark: {
    id: 'dark',
    name: 'Dark',
    style: DARK_STYLE,
  },
  light: {
    id: 'light',
    name: 'Light',
    style: LIGHT_STYLE,
  },
  voyager: {
    id: 'voyager',
    name: 'Voyager',
    style: VOYAGER_STYLE,
  },
};

export const INITIAL_MESSAGES = [
  {
    role: 'assistant',
    content: "Hello! I'm the manteo.ai assistant. I can help analyze your datasets. How can I assist you today?",
    suggestions: [
      'What questions can you answer?',
      'Brief description of the available datasets',
      'How can I visualize my data on a map?',
    ]
  }
];

/** Welcome chat message; uses workspace-specific example questions when provided. */
export function buildInitialMessages(workspace) {
  const base = INITIAL_MESSAGES[0];
  const custom = workspace?.example_questions;
  const suggestions =
    Array.isArray(custom) && custom.length > 0 ? custom : base.suggestions;
  return [{ ...base, suggestions }];
}
